export const xQuote = val => `"${val}"`;

const xRelation = {
  none: 0,
  eq: 1,
  ge: 2,
  le: 3,
  gt: 4,
  lt: 5,
  ne: 6,
};
const mapSelect = ({
  field, value, relation, isParameter = true,
}) =>
  `
{
    "StringChar": "'",
    "SelectSingles": [{
        "Operation": ${xRelation[relation]},
        "Value": ${xQuote(value)},
        "DefaultValue": null,
        "SendProperty": true,
        "choose": false,
        "recordAction": 0,
        "UniqueID": null,
        "KeyID": 0,
        "MasterID": 0,
        "CreateDate": "0001-01-01T00:00:00"
    }],
    "SelectRanges": [],
    "NotSelectSingles": [],
    "NotSelectRanges": [],
    "SelectActive": null,
    "_ParameterPrefix": "@p",
    "_ParameterCounter": 0,
    "_ParametersGiven": false,
    "CodeType": 1,
    "FieldName": ${xQuote(field)},
    "EntityName": ${xQuote(field)},
    "IsParameter": ${isParameter ? 'true' : 'false'},
    "Label": ${xQuote(field)},
    "IsHide": false,
    "IsNoSave": false,
    "IsRequired": false,
    "IsSkipSQL": false,
    "PadLeftChar": "\u0000",
    "PadLeftLen": 0,
    "Mask": null,
    "Domain": null,
    "Command": null,
    "SearchFields": null,
    "RecordName": null,
    "UseLinq": true,
    "FieldType": 0,
    "SkipInVariant": false,
    "Required": false,
    "SqlGroup": 1
}`;


export const xSelectSingle = selects =>
  `[
  ${selects.map(mapSelect).join`, `}
]`;



// WEBPACK FOOTER //
// ./src/utils/xSelect.js